import { trackEvent } from "@intercom/messenger-js-sdk";

/**
 * Rhapsody Pro funnel events. Intercom is the only analytics sink active on
 * the portal today (Google Analytics is scaffolded but has no key), so events
 * go there — visible on the user profile and usable for outbound. Event names
 * match the mobile app's Firebase events so the funnel reads the same on both
 * platforms.
 *
 * @param {string} name Snake_case event name, e.g. "paywall_purchase_completed"
 * @param {object} metadata Optional event metadata (package, error code, …)
 */
export function trackProEvent(
  name: string,
  metadata?: Record<string, string | number | boolean>
) {
  try {
    trackEvent(name, { platform: "web", ...metadata });
  } catch (e) {
    // Intercom not booted yet (signed-out or blocked) — drop the event.
  }
}
